import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useSelectByTheme } from "@/lib/themeAssets";
import { PLATFORM_NAME } from "@/lib/constants";
import { useNavigation } from "@/lib/navigation";

export default function Logo() {
  const navigation = useNavigation();
  const [mounted, setMounted] = useState(false);
  const [_, setThemeClass] = useState(() => {
    if (typeof document !== "undefined") {
      return document.documentElement.className;
    }
    return "";
  });
  useEffect(() => {
    if (typeof window === "undefined") return;
    const html = document.documentElement;
    const observer = new MutationObserver(() => {
      setThemeClass(html.className);
    });
    observer.observe(html, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    setMounted(true);
  }, []);
  const src = useSelectByTheme(
    "/education-school-svgrepo-com-white.svg",
    "/education-school-svgrepo-com.svg"
  );
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        justifyContent: "center",
      }}
      onClick={() => navigation.navigateTo("/")}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        {mounted && (
          <Box
            component="img"
            src={src}
            alt="Logo"
            sx={{
              height: 36,
            }}
          />
        )}
        <Typography variant="h6" noWrap component="div">
          {PLATFORM_NAME}
        </Typography>
      </Stack>
    </Box>
  );
}
